import { ApiEvent } from "./event.model";

export class ApiTask extends ApiEvent {
}  


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/models/task.model.ts